var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-menu",
    {
      attrs: {
        "offset-y": "",
        "close-on-content-click": false,
        "max-height": "300px"
      },
      scopedSlots: _vm._u([
        {
          key: "activator",
          fn: function(ref) {
            var on = ref.on
            return [
              _c(
                "v-btn",
                _vm._g(
                  {
                    attrs: {
                      small: "",
                      icon: "",
                      dark: "",
                      flat: "",
                      color: "primary",
                      "aria-label": _vm.$t("selectPackaging")
                    }
                  },
                  on
                ),
                [_c("v-icon", [_vm._v("expand_more")])],
                1
              )
            ]
          }
        }
      ]),
      model: {
        value: _vm.isOpen,
        callback: function($$v) {
          _vm.isOpen = $$v
        },
        expression: "isOpen"
      }
    },
    [
      _vm._v(" "),
      _c(
        "v-card",
        [
          _vm.enableSearch
            ? _c("v-text-field", {
                staticClass: "px-3 pt-3 pb-2",
                attrs: {
                  label: _vm.$t("search"),
                  placeholder: _vm.$t("searchPackagings"),
                  "prepend-icon": "search",
                  "single-line": "",
                  "hide-details": "",
                  clearable: ""
                },
                on: {
                  click: function($event) {
                    $event.stopPropagation()
                  }
                },
                model: {
                  value: _vm.searchText,
                  callback: function($$v) {
                    _vm.searchText = $$v
                  },
                  expression: "searchText"
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _c(
            "v-list",
            [
              _vm._l(_vm.filteredPackagings, function(item) {
                return _c(
                  "v-list-tile",
                  {
                    key: item.id,
                    on: {
                      click: function($event) {
                        return _vm.onSelectPackaging(item)
                      }
                    }
                  },
                  [
                    _c(
                      "v-list-tile-content",
                      [
                        _c("v-list-tile-title", [_vm._v(_vm._s(item.name))]),
                        _vm._v(" "),
                        _vm.showDetails
                          ? _c("v-list-tile-sub-title", [
                              _vm._v(
                                "\n            " +
                                  _vm._s(_vm.formatPackagingDetails(item)) +
                                  "\n          "
                              )
                            ])
                          : _vm._e()
                      ],
                      1
                    )
                  ],
                  1
                )
              }),
              _vm._v(" "),
              _vm.filteredPackagings.length === 0
                ? _c(
                    "v-list-tile",
                    [
                      _c(
                        "v-list-tile-content",
                        [
                          _c(
                            "v-list-tile-title",
                            { staticClass: "grey--text" },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(_vm.$t("noPackagingsFound")) +
                                  "\n          "
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e()
            ],
            2
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-532c7b82", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-532c7b82","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PackagingSelector.vue
// module id = null
// module chunks = 